<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Node Server Management
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <download-csv ref="exportNow" :data="exportJson" name="starsender_node_servers.csv"
                                style="display: none"></download-csv>
                            <a v-on:click="toggleModal('new_node_server')" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Add Node Server
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <NodeServerTable/>
                    </div>
                </div>
            </div>
            <modal name="new_node_server" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddNodeServer/>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import NodeServerTable from "@/components/tables/NodeServer.vue";
    import AddNodeServer from "@/components/forms/admin/AddNodeServer.vue";
    import moment from 'moment'

    export default {
        components: {
            NodeServerTable,
            AddNodeServer
        },
        data() {
            return {
                exportJson: []
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
        },
        methods: {
            async exportNodeServers() {
                try {
                    this.$toast.info("Please wait...");

                    // Get all node servers without pagination
                    let response = await this.$store.dispatch('admin_node_servers_list', {
                        page: 1,
                        limit: 1000 // Get all records
                    });

                    let rawData = response.data.data.node_servers || [];
                    let final = [];

                    for (let i = 0; i < rawData.length; i++) {
                        final.push({
                            "ID": rawData[i].id,
                            "Server UUID": rawData[i].server_uuid,
                            "URL": rawData[i].url,
                            "Token": rawData[i].token,
                            "Device Count": rawData[i].device_count,
                            "Multi Device": rawData[i].multidevice == 1 ? 'Yes' : 'No',
                            "Dev Only": rawData[i].dev_only == 1 ? 'Yes' : 'No',
                            "Status": rawData[i].hide == 1 ? 'Hidden' : 'Visible',
                            "Created At": moment.unix(rawData[i].created_at / 1000).format("YYYY-MM-DD HH:mm:ss"),
                            "Updated At": moment.unix(rawData[i].updated_at / 1000).format("YYYY-MM-DD HH:mm:ss"),
                        });
                    }

                    this.exportJson = final;
                    this.$refs.exportNow.$el.click();
                } catch (err) {
                    this.$toast.error("Failed to export data");
                    console.error(err);
                }
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
        },
    };
</script>
